import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    Application,
    ApplicationStatusEnum,
    CreateApplication,
    Kpi,
    Page,
    PageMetadata
} from '@tran-monorepo/interfaces';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApplicationsService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiConfig[1].uri}/v1/applications`;

    public getApplications(
        page: number,
        pageSize: number,
        filterParams: HttpParams
    ): Observable<Page<Application, PageMetadata>> {
        let params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString());
        filterParams.keys().forEach(key => {
            params = params.set(key, filterParams.get(key) || '');
        });
        return this.http.get<Page<Application, PageMetadata>>(this.baseUrl, { params });
    }

    public getApplication(id: string): Observable<Application> {
        return this.http.get<Application>(`${this.baseUrl}/${id}`);
    }

    public getApplicationKpis(id: string): Observable<Kpi[]> {
        return this.http.get<Kpi[]>(`${this.baseUrl}/${id}/kpis`);
    }

    public updateApplication(applicationId: string, application: Partial<CreateApplication>): Observable<Application> {
        return this.http.patch<Application>(`${this.baseUrl}/${applicationId}`, application);
    }

    public transitionStatus(applicationId: string, status: ApplicationStatusEnum): Observable<Application> {
        return this.http.post<Application>(`${this.baseUrl}/${applicationId}/transition`, { status });
    }

    public exportApplications(): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/export`, null);
    }

    public deleteApplication(applicationId: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${applicationId}`);
    }
}
